import {createQueryKeys} from '@lukemorales/query-key-factory'
import {api} from 'api'

export const contractTemplates = createQueryKeys('contractTemplates', {
  list: {
    queryKey: null,
    queryFn: () => api.contractTemplates.list(),
  },
})
